import { t as e } from "./utils-DQJjwn-K.js";
import "react";
import { CheckIcon as t } from "lucide-react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Slot as i } from "@radix-ui/react-slot";
import { cva as a } from "class-variance-authority";
import * as o from "@radix-ui/react-dropdown-menu";
//#region src/components/ui/button.tsx
var s = a([
	"inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md cursor-pointer",
	"text-btn font-btn transition-all disabled:pointer-events-none disabled:opacity-50",
	"[&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0",
	"outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[length:var(--focus-ring-width)]",
	"aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
].join(" "), {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/90",
			destructive: ["bg-destructive text-white hover:bg-destructive/80", "focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60"].join(" "),
			outline: ["border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground", "dark:bg-input/30 dark:border-input dark:hover:bg-input/50"].join(" "),
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
			"ghost-destructive": "text-destructive hover:bg-destructive/10 hover:text-destructive dark:hover:bg-destructive/20",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-btn px-3 py-1.5 has-[>svg]:px-2.5",
			sm: "h-btn-sm rounded-md gap-1.5 px-2.5 has-[>svg]:px-2",
			lg: "h-btn-lg rounded-md px-5 has-[>svg]:px-3",
			icon: "size-btn",
			"icon-sm": "size-btn-sm",
			"icon-lg": "size-btn-lg"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function c({ className: t, variant: r, size: a, isAsChild: o = !1, ...c }) {
	return /* @__PURE__ */ n(o ? i : "button", {
		"data-slot": "button",
		className: e(s({
			variant: r,
			size: a,
			className: t
		})),
		...c
	});
}
//#endregion
//#region src/components/ui/dropdown-menu.tsx
function l({ ...e }) {
	return /* @__PURE__ */ n(o.Root, {
		"data-slot": "dropdown-menu",
		...e
	});
}
function u({ ...e }) {
	return /* @__PURE__ */ n(o.Trigger, {
		"data-slot": "dropdown-menu-trigger",
		...e
	});
}
function d({ className: t, sideOffset: r = 4, ...i }) {
	return /* @__PURE__ */ n(o.Portal, { children: /* @__PURE__ */ n(o.Content, {
		"data-slot": "dropdown-menu-content",
		sideOffset: r,
		className: e("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md", t),
		...i
	}) });
}
function f({ ...e }) {
	return /* @__PURE__ */ n(o.Group, {
		"data-slot": "dropdown-menu-group",
		...e
	});
}
function p({ className: t, inset: r, variant: i = "default", ...a }) {
	return /* @__PURE__ */ n(o.Item, {
		"data-slot": "dropdown-menu-item",
		"data-inset": r,
		"data-variant": i,
		className: e("focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", t),
		...a
	});
}
function m({ className: i, children: a, checked: s, ...c }) {
	return /* @__PURE__ */ r(o.CheckboxItem, {
		"data-slot": "dropdown-menu-checkbox-item",
		className: e("group focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", i),
		checked: s,
		...c,
		children: [/* @__PURE__ */ n("span", {
			className: "border-primary group-data-[state=checked]:bg-primary group-data-[state=checked]:text-primary-foreground pointer-events-none absolute left-2 flex size-4 items-center justify-center rounded-[4px] border",
			children: /* @__PURE__ */ n(o.ItemIndicator, { children: /* @__PURE__ */ n(t, { className: "size-3" }) })
		}), a]
	});
}
function h({ ...e }) {
	return /* @__PURE__ */ n(o.RadioGroup, {
		"data-slot": "dropdown-menu-radio-group",
		...e
	});
}
function g({ className: i, children: a, ...s }) {
	return /* @__PURE__ */ r(o.RadioItem, {
		"data-slot": "dropdown-menu-radio-item",
		className: e("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", i),
		...s,
		children: [/* @__PURE__ */ n("span", {
			className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center",
			children: /* @__PURE__ */ n(o.ItemIndicator, { children: /* @__PURE__ */ n(t, { className: "size-4" }) })
		}), a]
	});
}
function _({ className: t, inset: r, ...i }) {
	return /* @__PURE__ */ n(o.Label, {
		"data-slot": "dropdown-menu-label",
		"data-inset": r,
		className: e("px-2 py-1.5 text-sm font-medium data-[inset]:pl-8", t),
		...i
	});
}
function v({ className: t, ...r }) {
	return /* @__PURE__ */ n(o.Separator, {
		"data-slot": "dropdown-menu-separator",
		className: e("bg-border -mx-1 my-1 h-px", t),
		...r
	});
}
//#endregion
export { p as a, g as c, c as d, f as i, v as l, m as n, _ as o, d as r, h as s, l as t, u };

//# sourceMappingURL=dropdown-menu-Bt4mgeUb.js.map